import { render, staticRenderFns } from "./wordsPreview.vue?vue&type=template&id=dcec5cbe&scoped=true&"
import script from "./wordsPreview.vue?vue&type=script&lang=js&"
export * from "./wordsPreview.vue?vue&type=script&lang=js&"
import style0 from "./wordsPreview.vue?vue&type=style&index=0&id=dcec5cbe&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcec5cbe",
  null
  
)

export default component.exports